<template>
  <footer class="border-t border-border bg-muted/40">
    <div class="max-w-7xl mx-auto px-4 py-12">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <!-- Logo and description -->
        <div class="flex flex-col gap-4">
          <router-link :to="{ name: 'home' }" class="flex items-center gap-2">
            <img
              class="h-16 w-auto"
              src="@/assets/images/logo.png"
              alt="UPChelas logotipo"
            />
            <span class="font-semibold text-lg text-foreground">UPChelas</span>
          </router-link>
          <p class="text-sm text-muted-foreground leading-relaxed">
            A Unidade Pastoral de Chelas é orientada pelos Frades Menores Conventuais que tentam viver o Evangelho ao jeito de S. Francisco de Assis.
          </p>
        </div>

        <!-- Quick links -->
        <div>
          <h3 class="font-semibold text-sm text-foreground mb-4">Links Rápidos</h3>
          <nav class="flex flex-col gap-2">
            <router-link :to="{ name: 'pastoralUnit' }" class="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150">
              Unidade Pastoral
            </router-link>
            <router-link :to="{ name: 'baptism' }" class="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150">
              Batismo
            </router-link>
            <router-link :to="{ name: 'marriage' }" class="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150">
              Matrimónio
            </router-link>
            <router-link :to="{ name: 'catechism' }" class="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150">
              Catequese
            </router-link>
            <router-link :to="{ name: 'conchas' }" class="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150">
              Conchas
            </router-link>
          </nav>
        </div>

        <!-- Contact and app -->
        <div>
          <h3 class="font-semibold text-sm text-foreground mb-4">Contacto</h3>
          <div class="flex flex-col gap-2 text-sm text-muted-foreground mb-6">
            <router-link :to="{ name: 'contacts' }" class="hover:text-foreground transition-colors duration-150">
              Ver todos os contactos
            </router-link>
          </div>

          <h3 class="font-semibold text-sm text-foreground mb-4">App UPChelas</h3>
          <a
            href="https://play.google.com/store/apps/details?id=com.upchelas&hl=pt_BR&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
            target="_blank"
            rel="noopener noreferrer"
            class="inline-block"
          >
            <img
              alt="Disponível no Google Play"
              class="h-10 w-auto"
              src="https://play.google.com/intl/en_us/badges/static/images/badges/pt_badge_web_generic.png"
            />
          </a>
        </div>
      </div>
    </div>

    <!-- Copyright bar -->
    <div class="border-t border-border">
      <div class="max-w-7xl mx-auto px-4 py-4">
        <p class="text-xs text-muted-foreground text-center">
          &copy; {{ new Date().getFullYear() }} Unidade Pastoral de Chelas. Todos os direitos reservados.
        </p>
      </div>
    </div>
  </footer>
</template>
